
import { useState } from 'react';

export default function Testimonials() {
  const [activeTab, setActiveTab] = useState('guests');

  const guestTestimonials = [
    {
      id: 1,
      name: 'Sarah Mitchell',
      location: 'Denver, CO',
      rating: 5,
      text: 'Our stay at Alpine Vista was absolutely magical. The luxury amenities combined with the stunning mountain views created an unforgettable experience. The staff went above and beyond to make our anniversary special.',
      image: 'https://public.readdy.ai/ai/img_res/58b0a93d3db80035e98407f7d5dedd40.jpg',
      experience: 'Alpine Vista Retreat'
    },
    {
      id: 2,
      name: 'Michael Chen',
      location: 'San Francisco, CA',
      rating: 5,
      text: 'As someone who travels frequently for business, I was blown away by the quality and attention to detail. The perfect blend of adventure and relaxation. Already planning our next visit with the family.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20businessman%20in%20his%2040s%20with%20confident%20smile%2C%20natural%20outdoor%20lighting%2C%20business%20casual%20attire%2C%20testimonial%20portrait%20for%20luxury%20hospitality%20website&width=80&height=80&seq=guest-michael-001&orientation=squarish',
      experience: 'Redwood Forest Haven'
    },
    {
      id: 3,
      name: 'Emma Rodriguez',
      location: 'Austin, TX',
      rating: 5,
      text: 'The Desert Star Sanctuary exceeded all expectations. Watching the sunrise from our private deck while enjoying gourmet coffee was pure bliss. This is glamping at its finest.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Hispanic%20woman%20in%20her%2030s%20with%20bright%20smile%2C%20natural%20lighting%2C%20bohemian%20style%2C%20testimonial%20portrait%20photography%20for%20outdoor%20hospitality%20brand&width=80&height=80&seq=guest-emma-001&orientation=squarish',
      experience: 'Desert Star Sanctuary'
    }
  ];

  const investorTestimonials = [
    {
      id: 1,
      name: 'Robert Harrison',
      company: 'Harrison Capital Partners',
      rating: 5,
      text: 'OED Glamping has consistently delivered on their promises. Our investment in the Mountain Ridge project has exceeded projected returns by 15%. Their team\'s expertise in site selection and development is unmatched.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20senior%20businessman%20in%20his%2050s%20with%20confident%20expression%2C%20business%20suit%2C%20corporate%20portrait%20photography%20for%20investment%20testimonial%2C%20executive%20style&width=80&height=80&seq=investor-robert-001&orientation=squarish',
      investment: '$3.2M Investment'
    },
    {
      id: 2,
      name: 'Jennifer Walsh',
      company: 'Sustainable Ventures LLC',
      rating: 5,
      text: 'What impressed me most was their commitment to sustainable development practices. The ROI has been excellent, but knowing we\'re creating positive environmental impact makes this partnership even more valuable.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20businesswoman%20in%20her%2040s%20with%20warm%20professional%20smile%2C%20business%20attire%2C%20corporate%20portrait%20for%20investment%20testimonial%2C%20executive%20style%20photography&width=80&height=80&seq=investor-jennifer-001&orientation=squarish',
      investment: '$2.8M Investment'
    },
    {
      id: 3,
      name: 'David Kim',
      company: 'Pacific Real Estate Group',
      rating: 5,
      text: 'The transparency and communication throughout the development process has been exceptional. OED\'s market analysis and execution capabilities have made this one of our most successful hospitality investments.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20businessman%20in%20his%2040s%20with%20professional%20smile%2C%20business%20suit%2C%20corporate%20executive%20portrait%20photography%20for%20investment%20testimonial&width=80&height=80&seq=investor-david-001&orientation=squarish',
      investment: '$4.1M Investment'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Our <span className="text-emerald-600">Community Says</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hear from our satisfied guests and successful investment partners who have experienced the OED Glamping difference.
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div className="bg-white rounded-full p-1 shadow-lg">
            <button
              onClick={() => setActiveTab('guests')}
              className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                activeTab === 'guests'
                  ? 'bg-emerald-600 text-white'
                  : 'text-gray-600 hover:text-emerald-600'
              }`}
            >
              Guest Experiences
            </button>
            <button
              onClick={() => setActiveTab('investors')}
              className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                activeTab === 'investors'
                  ? 'bg-emerald-600 text-white'
                  : 'text-gray-600 hover:text-emerald-600'
              }`}
            >
              Investor Success
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {(activeTab === 'guests' ? guestTestimonials : investorTestimonials).map((testimonial) => (
            <div key={testimonial.id} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">
                    {activeTab === 'guests' ? testimonial.location : testimonial.company}
                  </p>
                  <div className="flex items-center mt-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-4">"{testimonial.text}"</p>
              
              <div className="text-emerald-600 font-semibold text-sm">
                {activeTab === 'guests' ? testimonial.experience : testimonial.investment}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}